import { useState } from 'react';
import { Tooltip } from 'antd';

function App({ item, amount }) {
  const [image, setImage] = useState('');

  const img = new Image();
  img.src = `/items/${item}.png`;
  img.onerror = () => {
    img.src = '/items/snowball.png';
    setImage(img.src);
  };
  img.onload = () => {
    setImage(img.src);
  };

  const concatString = (str) => {
    if (str.length > 14) {
      return `${str.substring(0, 10)}...`;
    }
    return str;
  };

  return (
    <Tooltip title={`${item} - ${amount}`}>
      <div style={{ color: '#c0c0c0', fontSize: '0.8em', fontFamily: 'monospace', width: '96px', height: '96px', backgroundColor: 'rgba(0,0,0,0.1)', position: 'relative' }}>
        <span style={{ width: '64px', height: '64px', position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
          <img width="64px" height="64px" src={image} alt="" />
        </span>
        <span style={{ position: 'absolute', bottom: '0', right: '0', backgroundColor: 'rgba(0,0,0,0.1)', padding: '2px 4px', borderRadius: '4px' }}>
          {amount}
        </span>
        <span style={{ position: 'absolute', top: '0', left: '0', backgroundColor: 'rgba(0,0,0,0.1)', padding: '2px 4px', borderRadius: '4px' }}>
          {concatString(item)}
        </span>
      </div>
    </Tooltip>
  );
}

export default App;
